import Laravel from './Laravel'

export default {
  async list(shopId) {
    try {
      const { data: items } = await Laravel.get(`/shops/${shopId}/items`)
      return items
    } catch (error) {
      return Promise.reject(error)
    }
  }, // list
}
